<template>
  <InsurancePlanFilter inline close-on-select start-on-root @update:model-value="insuranceChanged">
    <template #activator>
      <sp-button class="activator" variant="appearance-link">{{ title }}</sp-button>
    </template>
  </InsurancePlanFilter>
</template>

<script setup>
import InsurancePlanFilter from "../../shared/components/InsurancePlanFilter.ce.vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["insurance-changed"]);

function insuranceChanged(value) {
  emit("insurance-changed", value);
}
</script>
